<div class="select-multiple-key-component">
  <label class="select-label" *ngIf="label!=''">{{label}}</label>
  <div class="select-multiple">
    <ul id="multiple" #listContainer>
      <!-- li with class no-color-li is to keeps old checkboxes style with no color like transitions or users -->
      <li *ngFor="let opt of options; let i = index" 
          [ngClass]="{'selected-li': opt.selected, 
                      'disabled-li': opt.disabled,
                      'no-color-li': !opt.options.hasOwnProperty('color')
               }">
        <label class="checklabel checkstage" 
          ><span class="color-bar"  [ngStyle]="opt.options.hasOwnProperty('color') ? {'background-color': opt.options?.color} : ''" ></span><em>{{opt.description}}</em>
          <input type="checkbox"
          [name]="'option'+i"
          [(ngModel)]="opt.selected"
          value="{{opt.key}}"
          (change)="onChange(opt)"
          [disabled]="opt.disabled"
          />
          <span *ngIf="!opt.disabled" class="checkmark"></span>
        </label>
      </li>
    </ul>
  </div>
</div>
